import { Injectable } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';

@Injectable()
export class LocalDbService {
  constructor(protected localStorage: LocalStorage) {}
}
